import { BasicTable } from '@fullscreendigital/carrefour-dex-fe'
import s from './ReportsLinks.modules.scss'
import { Link } from 'react-router-dom'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const columns = [
  {
    field: 'reportName',
    title: 'Nume raport'
  },
  {
    field: 'link',
    title: 'Link raport',
    render: row => (
      <Link to={row.link} target="_blank" rel="noopener noreferrer">
        <OpenInNewIcon />
      </Link>
    )
  }
]

const rows = [
  {
    reportName: 'Rapoarte Volumetrie Looker Studio',
    link: 'https://lookerstudio.google.com/reporting/e4b72479-2aad-4c9c-89f4-6a2d9de6b0a0/page/Fk6vE'
  }
]

const ReportsLinks = () => {
  return (
    <div className={s.mainContainer}>
      <BasicTable
        columns={columns}
        rows={rows}
        containerProps={{
          className: s.table
        }}
      />
    </div>
  )
}

export default ReportsLinks
